import { render, staticRenderFns } from "./widget_portfolio_changes.vue?vue&type=template&id=fd8c8f10&scoped=true&"
import script from "./widget_portfolio_changes.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_changes.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_changes.vue?vue&type=style&index=0&id=fd8c8f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8c8f10",
  null
  
)

export default component.exports